import type { Task } from "~skillBuilder/utils/types";

import { image, title } from "../../contentBlocks";

export const TspSwingExperience = {
  name: "The Swing Experience",
  uniqueName: "tsp-swing-experience",
  icon: "Lesson",
  durationTimeText: "2 min",
  steps: [
    // Step 1
    {
      nextButtonText: "Start",
      questions: [
        // Question 1.1
        {
          attribute: "the-sub-playbook.swing-experience/overview",
          label: "",
          answerType: {
            type: "CONTENT",
            value: "valid",
            markdown: `
${title({ text: "The Swing Experience", durationTimeText: "2 min" })}
<p>Learn how to navigate the Swing platform and the baseline professional standards expected by every school.</p>
<div align="center">
<div style="max-width:300px;width:100%;">
${image({ url: "https://res.cloudinary.com/swingeducation/image/upload/fl_preserve_transparency/v1732044836/skillbuilderAssets/optimized/count-on-intro.jpg", alt: "Illustration of a substitute teacher ready to support a classroom." })}
</div>
</div>
`,
          },
        },
      ],
    },
    // Step 2
    {
      questions: [
        // Question 2.1
        {
          attribute: "the-sub-playbook.swing-experience/platform",
          label: "The Swing Experience",
          answerType: {
            type: "CONTENT",
            value: "valid",
            markdown: `
<div>
  <p>Subbing is a great way to work in schools, support students, and make an impact. Schools count on substitutes to show up with professionalism, and be a reliable and consistent presence on campus, filling in where they are needed most.</p>
  <p>Swing is a modern way of subbing. You can view available opportunities at different K-12 districts near you. There are jobs available for substitute teachers, paraprofessionals, and more across elementary, middle and high school. When you find a job that&rsquo;s a good fit, simply sign up, right from your phone or a computer. This puts you in complete control of your schedule and earnings.</p>
  <p>As you show up, stay professional, and follow through with your commitments, you unlock more consistent work and higher-value requests. We offer weekly pay for your impact, and referral incentives when you refer friends and colleagues.</p>
</div>
`,
          },
        },
      ],
    },
    // Step 3
    {
      nextButtonText: "Next Lesson",
      questions: [
        // Question 3.1
        {
          attribute: "the-sub-playbook.swing-experience/resources",
          label: "Resources and Assistance",
          answerType: {
            type: "CONTENT",
            value: "valid",
            markdown: `
<div>
  <p>Swing Education&rsquo;s Support Team is there to help every step of the way, to guide your platform experience. We have both AI and human powered knowledge base to answer questions and navigate any challenges you encounter along the way. You can reach the team by Chat, email, or phone for your convenience.</p>
  <p><strong>Connect with Swing:</strong></p>
</div>

- 🌐 [Help Center](https://swingeducation.com/help-center/): Your DIY resource hub.
- 💬 Live Chat: Available 5 AM – 4 PM PST.
- 📧 Email: support@swingeducation.com
- 📱 Phone: (650) 413-9268

<div>
  <p>Swing has a robust resource library to provide you with helpful tips and optional Skill Builder modules&mdash;just like this one! Designed to help you enhance professionalism, and grow your classroom management skills to help posture you for success.</p>
</div>
`,
          },
        },
      ],
    },
  ],
} as const satisfies Task;
